import Modal from './Modal'
import { MODAL_SIZE } from './createReactModal'
import { _ } from '../gettext'

/**
 * Create a modal with given content
 *
 * @param {string} title
 * @param {string} content
 * @param {boolean} contentWithFooter
 * @param {string|null} contentSizeClass
 */
export default function createModal (
  title,
  content,
  contentWithFooter = false,
  contentSizeClass = MODAL_SIZE.LG,
) {
  const modalContent = contentWithFooter === true
    ? content
    : `
    <div class="modal-body">${content}</div>
    <div class="modal-footer">
      <a href="#" class="btn btn-secondary modal-close">${_('Zavřít')}</a>
    </div>`

  title = title
    ? `
      <div class="modal-header">
        <h5 class="modal-title" style="margin: auto 0;">${title}</h5>
        <button type="button" class="close modal-close">
            <span>&times;</span>
        </button>
      </div>
    `
    : ''

  document.querySelector('#modal-container').innerHTML = `
    <div class="modal" role="dialog">
        <div class="modal-dialog modal-dialog-centered ${contentSizeClass}" role="document">
            <div class="modal-content">
                ${title}
                <div class="modal-content-inner">
                    ${modalContent}
                </div>
            </div>
        </div>
    </div>`

  return new Modal($('body').find('.modal:last'))
}
